import React, { useEffect, useState } from "react";
import LoginComponent from "../loginComponent";
import PureJSComponentFactory from "../Pages/Factory/pureJSComponentFactory";
import HttpService from "../../Services/httpService";
import {
    unProcPath,
    authStorageKey,
    userDetailsStorageKey,
    userMenuStorageKey,
    apiRoot,
    authMethode,
    authBody,
    jobId
} from "../../General/globals";

const UserLogin = () => {
    const [loginPgUI, setLoginPgUI] = useState([]);

    useEffect(() => {
        const getloginUI = async () => {
            const data = {
                info: {
                    doctype: "page",
                    docno: "custom-login-ui",
                },
            };
            const headers = {
                "Content-Type": "application/json",
            };
            const reqBody = new HttpService().getProcPostBodyString(
                jobId || authBody?.job_id,
                "PWA.LoadLayout",
                data,
                "single"
            );
            let loginUI = await new HttpService().postServer(
                apiRoot,
                unProcPath,
                headers,
                reqBody
            );

            const parsedUI = JSON.parse(loginUI?.[0]?.layoutinfo)?.layout;
            const loginpageUI = new PureJSComponentFactory().scaffoldComponent(
                parsedUI
            );
            setLoginPgUI(loginpageUI);
        };

        getloginUI();
    }, []);

    return (
        <div>
            {loginPgUI}
            {/* <LoginComponent /> */}
        </div>
    );
};

export default UserLogin;
